import { render, staticRenderFns } from "./industryLocal.vue?vue&type=template&id=c81ec222&scoped=true"
import script from "./industryLocal.vue?vue&type=script&lang=js"
export * from "./industryLocal.vue?vue&type=script&lang=js"
import style0 from "./industryLocal.vue?vue&type=style&index=0&id=c81ec222&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c81ec222",
  null
  
)

export default component.exports